export default __webpack_public_path__ + "static/media/Xarathrustra-minion-particle_0005_Div-impact.b659831f.png";